/**
 * UPSELL POP-UP - "You may be interested in..."
 * Exibe pop-up após adicionar produto ao carrinho
 * Oferece: Get Priority e High-Res Digital Copy
 */

(function() {
  'use strict';

  // Configuração
  const CONFIG = {
    UPSELL_PRODUCTS: {
      'get-priority-skip-the-line': {
        title: 'Get Priority - Skip the line',
        price: '€9,99'
      },
      'high-res-digital-copy': {
        title: 'High-Res Digital Copy',
        price: '€4,99'
      }
    },
    SHOW_POPUP_DELAY: 300, // ms após adicionar ao carrinho
    ADDED_PRODUCTS: new Set() // Produtos já adicionados (para não duplicar)
  };

  // Cache de elementos
  let overlay = null;
  let modal = null;
  let closeBtn = null;
  let continueBtn = null;
  let addButtons = null;
  let addedItemImage = null;
  let addedItemTitle = null;

  /**
   * Inicializa o pop-up
   */
  function init() {
    // Aguarda DOM estar pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
  }

  /**
   * Configura os elementos e eventos
   */
  function setup() {
    // Cache de elementos
    overlay = document.getElementById('upsellPopupOverlay');
    modal = overlay?.querySelector('.upsell-popup-modal');
    closeBtn = overlay?.querySelector('.upsell-popup-close');
    continueBtn = overlay?.querySelector('.upsell-popup-continue-btn');
    addButtons = overlay?.querySelectorAll('.upsell-item-add-btn');
    addedItemImage = document.getElementById('upsellAddedItemImage');
    addedItemTitle = document.getElementById('upsellAddedItemTitle');

    if (!overlay) {
      console.warn('Upsell popup não encontrado no DOM');
      return;
    }

    // Event listeners
    closeBtn?.addEventListener('click', hidePopup);
    continueBtn?.addEventListener('click', handleContinue);
    overlay.addEventListener('click', handleOverlayClick);

    // Botões ADD
    addButtons?.forEach(btn => {
      btn.addEventListener('click', handleAddUpsell);
    });

    // Interceptar adicionar ao carrinho
    interceptAddToCart();
  }

  /**
   * Verifica quais upsells já existem no carrinho
   * e marca os botões correspondentes como ADDED
   * IMPORTANTE: Só verifica itens que foram marcados como upsell
   */
  function checkExistingUpsells() {
    // Só processa se o overlay estiver pronto
    if (!overlay || !addButtons) return;
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Para cada item no carrinho
        cart.items.forEach(item => {
          // Verifica se tem a propriedade _upsell_item = true
          const isUpsell = item.properties && item.properties._upsell_item === 'true';
          
          if (isUpsell) {
            const handle = item.handle;
            
            // Marca como adicionado na memória
            CONFIG.ADDED_PRODUCTS.add(handle);
            
            // Procura e atualiza o botão correspondente
            const button = document.querySelector(`.upsell-item-add-btn[data-product-handle="${handle}"]`);
            if (button) {
              button.classList.remove('loading');
              button.classList.add('added');
              button.textContent = 'ADDED ✓';
              button.disabled = true;
            }
          }
        });
      })
      .catch(error => {
        console.error('Erro ao verificar upsells no carrinho:', error);
      });
  }

  /**
   * Intercepta eventos de adicionar ao carrinho
   * IMPORTANTE: Só intercepta fetch, NÃO formulários (para evitar duplicação)
   */
  function interceptAddToCart() {
    // Só intercepta Fetch API (temas modernos)
    // NÃO intercepta formulários (isso causava duplicação)
    interceptFetch();
  }

  /**
   * Intercepta chamadas fetch para /cart/add
   * IMPORTANTE: Só intercepta para mostrar popup, não modifica a requisição
   */
  function interceptFetch() {
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      
      // Intercepta QUALQUER chamada para /cart/add
      if (typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'))) {
        return originalFetch.apply(this, args)
          .then(response => {
            // Não interfere com a resposta, só observa
            if (response.ok) {
              // Clone para não consumir a resposta original
              response.clone().json().then(data => {
                // Só mostra popup se não for um upsell sendo adicionado
                if (data && !isUpsellProduct(data)) {
                  handleCartAddSuccess(data);
                }
              }).catch(err => {
                // Ignora erros de parsing silenciosamente
              });
            }
            return response;
          });
      }
      
      return originalFetch.apply(this, args);
    };
  }
  
  /**
   * Verifica se o item adicionado é um produto de upsell
   */
  function isUpsellProduct(item) {
    if (!item) return false;
    
    // Verifica pelo handle
    const handle = item.handle || '';
    const isUpsellByHandle = handle.includes('priority') || handle.includes('digital-copy');
    
    // Verifica pelas properties
    const hasUpsellProperty = item.properties && item.properties._upsell_item === 'true';
    
    return isUpsellByHandle || hasUpsellProperty;
  }

  /**
   * handleFormSubmit - REMOVIDO
   * Causava duplicação ao interceptar formulários
   * Agora só usamos interceptFetch()
   */

  /**
   * Manipula sucesso ao adicionar produto ao carrinho
   */
  function handleCartAddSuccess(item) {
    // Verifica se é um dos produtos de upsell (não mostrar popup nesse caso)
    const isUpsellProduct = Object.keys(CONFIG.UPSELL_PRODUCTS).some(handle => 
      item.handle === handle || item.product_title?.includes('Priority') || item.product_title?.includes('Digital Copy')
    );

    if (isUpsellProduct) {
      return; // Não mostra popup para upsells
    }

    // Guarda o ID/handle do produto principal (para associar upsells depois)
    if (item.product_id) {
      sessionStorage.setItem('last_added_product_id', item.product_id);
      sessionStorage.setItem('last_added_product_title', item.product_title || 'Produto');
    }

    // Atualiza informações do produto adicionado
    if (addedItemImage && item.featured_image) {
      addedItemImage.src = item.featured_image.url;
      addedItemImage.alt = item.product_title;
    }
    
    if (addedItemTitle) {
      addedItemTitle.textContent = item.product_title || 'Produto';
    }

    // Mostra o popup após delay
    setTimeout(() => {
      showPopup();
    }, CONFIG.SHOW_POPUP_DELAY);
  }

  /**
   * Mostra o pop-up
   */
  function showPopup() {
    if (!overlay) return;

    overlay.style.display = 'flex';
    document.body.classList.add('upsell-popup-open');
    
    // Trigger animação
    setTimeout(() => {
      overlay.classList.add('active');
    }, 10);

    // Verifica quais upsells já estão no carrinho (só quando mostrar pop-up)
    checkExistingUpsells();
  }

  /**
   * Esconde o pop-up
   */
  function hidePopup() {
    if (!overlay) return;

    overlay.classList.remove('active');
    
    setTimeout(() => {
      overlay.style.display = 'none';
      document.body.classList.remove('upsell-popup-open');
    }, 300);
  }

  /**
   * Manipula clique no overlay (fechar ao clicar fora)
   */
  function handleOverlayClick(e) {
    if (e.target === overlay) {
      hidePopup();
    }
  }

  /**
   * Manipula clique no botão CONTINUE
   */
  function handleContinue() {
    hidePopup();
    // Opcional: redirecionar para carrinho
    // window.location.href = '/cart';
  }

  /**
   * Manipula clique em botão ADD de upsell
   */
  function handleAddUpsell(e) {
    const button = e.currentTarget;
    const productHandle = button.dataset.productHandle;

    // Previne duplicação - se já foi adicionado, não faz nada
    if (!productHandle || CONFIG.ADDED_PRODUCTS.has(productHandle)) {
      return;
    }

    // Previne cliques múltiplos rápidos
    if (button.disabled) {
      return;
    }
    
    // Desabilita botão temporariamente
    button.disabled = true;
    button.classList.add('loading');
    button.textContent = 'ADDING...';

    // Busca o produto pelo handle e adiciona ao carrinho
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        const variantId = product.variants[0].id;
        return addToCart(variantId);
      })
      .then(() => {
        // Sucesso - mantém botão em estado ADDED permanentemente
        button.classList.remove('loading');
        button.classList.add('added');
        button.textContent = 'ADDED ✓';
        button.disabled = true;
        CONFIG.ADDED_PRODUCTS.add(productHandle);
        
        // Atualiza carrinho
        updateCartUI();
      })
      .catch(error => {
        console.error('Erro ao adicionar upsell:', error);
        button.disabled = false;
        button.classList.remove('loading');
        button.textContent = 'ADD';
        alert('Erro ao adicionar produto. Tente novamente.');
      });
  }

  /**
   * Adiciona produto ao carrinho via AJAX
   * IMPORTANTE: Adiciona propriedades especiais e associa ao produto principal
   */
  function addToCart(variantId, quantity = 1) {
    // Obtém info do produto principal (adicionado antes)
    const mainProductId = sessionStorage.getItem('last_added_product_id') || '';
    const mainProductTitle = sessionStorage.getItem('last_added_product_title') || '';
    
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity,
          properties: {
            '_upsell_item': 'true',
            '_exclude_from_discounts': 'true',
            '_associated_product': mainProductTitle,
            '_associated_product_id': mainProductId
          }
        }]
      })
    }).then(response => {
      if (!response.ok) {
        throw new Error('Erro ao adicionar ao carrinho');
      }
      return response.json();
    });
  }

  /**
   * Atualiza UI do carrinho (drawer, contador, etc)
   * MELHORADO: Força refresh completo do cart drawer
   */
  function updateCartUI() {
    // Trigger evento do Shopify
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    
    // Fetch e atualizar
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Atualiza contador do carrinho
        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count-bubble, #cart-icon-bubble span');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.style.display = '';
          }
        });
        
        // Se o cart drawer estiver aberto, força atualização
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          fetch('/cart?sections=cart-drawer')
            .then(res => res.json())
            .then(sections => {
              const html = sections['cart-drawer'];
              if (html) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newContent = doc.querySelector('cart-drawer-items');
                const oldContent = cartDrawer.querySelector('cart-drawer-items');
                if (newContent && oldContent) {
                  oldContent.replaceWith(newContent);
                }
              }
            });
        }
      })
      .catch(err => {
        console.error('Erro ao atualizar carrinho:', err);
      });
  }

  /**
   * Reset botões ADD
   * NOTA: Não reseta botões que já foram adicionados
   */
  function resetAddButtons() {
    addButtons?.forEach(btn => {
      const handle = btn.dataset.productHandle;
      // Só reseta se não foi adicionado anteriormente
      if (!CONFIG.ADDED_PRODUCTS.has(handle)) {
        btn.disabled = false;
        btn.classList.remove('loading', 'added');
        btn.textContent = 'ADD';
      }
    });
  }

  // Inicializa
  init();

  // Expõe funções globalmente (opcional, para debug)
  window.UpsellPopup = {
    show: showPopup,
    hide: hidePopup
  };

})();

